import { request } from '@core/api';
import type { RootState } from '@core/redux/interface';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { ApiUserRole, UserProfile } from './types';
import { UserRoleApiToEnum } from './types';

const fetchProfile = createAsyncThunk(
  `userprofile/api/get/one`,
  async () => await request<{ role: ApiUserRole }>('GET', { path: ['userprofile'] }),
);

const userProfileSlice = createSlice({
  name: 'userProfile',
  initialState: null as UserProfile | null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProfile.fulfilled, (state, action) => ({
      role: UserRoleApiToEnum[action.payload.role],
    }));
  },
});

export const userProfileReducer = userProfileSlice.reducer;
export const userProfileActions = { ...userProfileSlice.actions, fetchProfile };
export const userProfileSelectors = {
  selectUserRole: ({ userProfile }: RootState) => userProfile?.role,
  selectUserProfile: ({ userProfile }: RootState) => userProfile,
};
